import React from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";

const FtPrivacyPolicy = () => {
  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle=" سياسة الخصوصية "
            title=" الرئيسية"
            subtitle=" سياسة الخصوصية"
          />
          <div className="small-container">
            <div className="card flex-fill accessibility-statement">
              <div className="inner-header text-center text-primary card-header p-3">
                <h1>سياسة الخصوصية</h1>
              </div>
              <div className="card-body">
                <div className="inner-content text-right account-wrapper login-black content ">
                  <p>
                    Massarwe.com ("الشركة") هي مطور ومشغل Fintrack - بما في ذلك
                    موقع الويب والعمليات الأخرى التي يمكن إجراؤها باستخدام
                    الترخيص المقدم من قبلها ("موقع الويب" و "الترخيص" ، على
                    التوالي). فيما يلي تفاصيل الإجراءات التي تعمل الشركة من
                    خلالها في جمع واستخدام التفاصيل الخاصة بك ، بما في ذلك
                    معلومات حول مكان وجودك عند استخدام الترخيص ("سياسة
                    الخصوصية"). الغرض من سياسة الخصوصية المفصلة هنا هو شرح
                    ممارسات الشركة فيما يتعلق بخصوصية مستخدمي الموقع ، وكيف
                    تستخدم الشركة المعلومات المقدمة لها من قبل مستخدمي الموقع أو
                    التي جمعتها عند استخدام الموقع.
                  </p>
                  <p>
                    يجب التأكيد على أن الشركة تعتبر حماية خصوصيتك أمراً في غاية
                    الأهمية ، وتبذل جهوداً كبيرة لحماية المعلومات المقدمة لها
                    بشكل صحيح. تتخذ الشركة إجراءات للحفاظ على أمن المعلومات
                    وخصوصيتك. قد تتغير سياسة خصوصية الشركة من وقت لآخر. في أي
                    حالة تقوم فيها الشركة بتغيير هذه السياسة بشكل كبير ، أي
                    تغيير يتعلق بالطريقة التي تستخدم بها الشركة المعلومات
                    والتفاصيل التي قدمتها ، ستعلن الشركة عن ذلك عن طريق وضع
                    إشعار مناسب على موقع الويب ، أو عن طريق إرسال رسالة بريد
                    إلكتروني.
                  </p>
                  <div className="card-header">
                    <h3 className="text-primary card-title">عام</h3>
                  </div>

                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      عند استخدام الموقع، يتم جمع معلومات عنك، بعضها يحدد هويتك
                      الشخصية وبعضها لا.
                    </li>
                    <li>
                      قد يُطلب منك تزويد الشركة بمعلومات مثل الاسم الكامل،
                      البريد الإلكتروني، ورقم الهوية، بالإضافة إلى تفاصيل عن
                      عملك.
                    </li>
                    <li>
                      لا يُطلب منك قانوناً تقديم المعلومات، ولكنها ضرورية لإنشاء
                      حسابك ومنح الترخيص.
                    </li>
                    <li>
                      تنطبق سياسة الخصوصية أيضاً على المعلومات التي تقدمها أثناء
                      استخدام الترخيص، أو التي يتم جمعها أثناء تصفح الموقع.
                    </li>
                    <li>
                      إذا زودت الشركة بمعلومات عن طرف ثالث، فأنت تقر بأنك حصلت
                      على موافقته الصريحة.
                    </li>
                    <li>
                      المعلومات التي تقدمها تُستخدم فقط للأغراض المحددة في سياسة
                      الخصوصية، ولن تُستخدم خارج هذا النطاق إلا بموجب القانون.
                    </li>
                    <li>
                      يمكنك إيقاف تلقي المواد التسويقية في أي وقت عبر البريد
                      الإلكتروني أو رابط الإزالة.
                    </li>
                    <li>
                      تُسجل الشركة تلقائياً معلومات مثل عنوان IP والصفحات التي
                      زرتها.
                    </li>
                    <li>
                      <span className="text-primary fw-bold">
                        {" "}
                        تُستخدم المعلومات للأغراض التالية:
                      </span>
                      <ol>
                        <li>عرض البيانات الخاصة بك.</li>
                        <li>مراقبة استخدام الترخيص.</li>
                        <li>تحسين الترخيص.</li>
                        <li>منع الاستخدامات غير الصحيحة.</li>
                        <li>فرض شروط الاستخدام.</li>
                        <li>التواصل مع العملاء وإرسال الإشعارات.</li>
                        <li>التحليل الإحصائي الداخلي.</li>
                        <li>الاستخدام في صفحة المقاصة من طرف ثالث.</li>
                      </ol>
                    </li>
                    <li>
                      إذا لم توافق على استخدام المعلومات بهذه الطرق، يُرجى عدم
                      استخدام الموقع أو الترخيص.
                    </li>
                    <li>
                      يجوز استخدام المعلومات (عدا محتوى الفواتير) لتحسين
                      الخدمات.
                    </li>
                    <li>
                      أي معلومات تقدمها للنشر يجب ألا تحتوي على بيانات شخصية لك
                      أو لطرف ثالث.
                    </li>
                    <li>
                      إذا استخدمت خدمات تتضمن ربطاً بطرف ثالث، فأنت توافق على
                      سياسة خصوصية ذلك الطرف.
                    </li>
                    <li>
                      يجوز استخدام معلوماتك لأغراض تسويقية، مثل إرسال رسائل عبر
                      البريد الإلكتروني أو SMS، بناءً على موافقتك الصريحة.
                    </li>
                    <li>
                      قد تتلقى مواد تسويقية إذا اشتريت ترخيصاً أو طلبت معلومات،
                      ولم تختر الانسحاب منها.
                    </li>
                    <li>
                      يجوز للشركة مشاركة معلوماتك مع أطراف ثالثة لأغراض تسويقية،
                      بموجب موافقتك.
                    </li>
                    <li>يمكنك الانسحاب من تلقي المواد التسويقية في أي وقت.</li>
                    <li>
                      الاختصاص القضائي في النزاعات سيكون حصرياً لمحكمة القدس،
                      ويُطبق القانون الإسرائيلي.
                    </li>
                  </ul>
                  <div className="card-header">
                    <h3 className="text-primary card-title">قاعدة البيانات</h3>
                  </div>

                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      عند استخدام الموقع، يتم جمع معلومات عنك، منها ما يحدد
                      هويتك الشخصية (مثل اسمك الكامل، البريد الإلكتروني، رقم
                      الهوية) ومنها ما لا يحدد هويتك (مثل الصفحات التي شاهدتها،
                      عنوان IP، إلخ).
                    </li>
                    <li>
                      قد يُطلب منك تزويد الشركة بتفاصيل شخصية ومهنية بغرض
                      استخدام بعض العمليات بكفاءة.
                    </li>
                    <li>
                      تسليم المعلومات الشخصية يتم بمحض إرادتك، ولا يوجد التزام
                      قانوني بذلك.
                    </li>
                    <li>
                      تنطبق سياسة الخصوصية على جميع البيانات المقدمة أثناء
                      التسجيل أو استخدام الترخيص.
                    </li>
                    <li>
                      إذا قدمت معلومات عن طرف ثالث، يجب أن تكون قد حصلت على
                      موافقته الصريحة لذلك.
                    </li>
                    <li>
                      المعلومات تُستخدم فقط وفقاً لتعليماتك أو بناءً على
                      القانون.
                    </li>
                    <li>
                      <span className="text-primary fw-bold">
                        {" "}
                        استخدام المعلومات يشمل:
                      </span>
                      <ol>
                        <li>عرض البيانات الخاصة بك.</li>
                        <li>مراقبة وتحسين استخدام الترخيص.</li>
                        <li>منع الاستخدامات غير الصحيحة.</li>
                        <li>إرسال رسائل بريدية لعملائك بناءً على طلبك.</li>
                        <li>إجراء تحليل إحصائي داخلي.</li>
                        <li>الاتصال بك لأغراض تشغيلية وتسويقية.</li>
                      </ol>
                    </li>
                    <li>
                      في حال عدم الرغبة باستخدام معلوماتك، يُرجى عدم استخدام
                      الترخيص.
                    </li>
                    <li>
                      قد تستخدم الشركة بيانات استخدام الخدمة (وليس محتوى
                      الفواتير) لأغراض التطوير والتحسين.
                    </li>
                    <li>
                      لا يجب أن تحتوي المحتويات التي تنشرها على معلومات شخصية
                      عنك أو عن غيرك.
                    </li>
                    <li>
                      إذا استخدمت خدمات مرتبطة بأطراف ثالثة، فعليك الالتزام
                      بسياساتهم.
                    </li>
                    <li>
                      يمكن استخدام معلوماتك لأغراض تسويقية بعد موافقتك الصريحة.
                    </li>
                    <li>
                      يمكنك إلغاء الاشتراك في أي وقت من خلال رابط "إزالة" أو عبر
                      البريد الإلكتروني support@massarwe.com.
                    </li>
                    <li>
                      لن تتم مشاركة معلوماتك مع طرف ثالث لأغراض تسويقية إلا بعد
                      تفويضك الصريح.
                    </li>
                    <li>
                      الاختصاص القضائي الحصري في جميع الأمور هو لمحكمة القدس.
                    </li>
                  </ul>
                  <div className="card-header">
                    <h3 className="text-primary card-title">
                      إفشاء معلومات عنك لأطراف ثالثة
                    </h3>
                  </div>

                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      يحق للشركة الكشف عن معلوماتك كلياً أو جزئياً، بما في ذلك
                      بيانات الموقع، للأطراف التالية وتحت الشروط التالية:
                    </li>
                    <li>
                      كجزء من استخدام النظام الذي يوفر خدمة "الفاتورة الموقعة
                      إلكترونياً" لعملائك فقط.
                    </li>
                    <li>
                      عندما يكون الكشف عن المعلومات ضرورياً لأغراض أمن المعلومات
                      أو تنفيذ العمليات عبر المنصة، على أن لا تستخدم الأطراف هذه
                      المعلومات لأغراض أخرى غير المصرح بها.
                    </li>
                    <li>
                      عند طلب الجهات القانونية أو القضائية ذلك بموجب القانون أو
                      إجراء قانوني.
                    </li>
                    <li>
                      إذا اكتشفت الشركة أن استخدامك للمنصة يخالف شروط الاستخدام
                      أو ينطوي على احتيال.
                    </li>
                    <li>
                      لنقل المعلومات لأغراض تفرضها القوانين أو إلى أطراف ذات
                      علاقة محاسبية أو قانونية بالشركة.
                    </li>
                    <li>
                      عند تفعيل استخدام تطبيق "WhatsApp"، قد يتم إرسال واستقبال
                      معلومات عبر التطبيق، وذلك فقط في إطار خدمة إدخال الفاتورة.
                      يخضع ذلك لشروط وسياسة خصوصية "WhatsApp":
                      <a
                        href="https://www.whatsapp.com/legal/business-terms-20210927"
                        target="_blank"
                      >
                        شروط واتساب للأعمال
                      </a>
                      .
                    </li>
                    <li>
                      قد يحتوي الموقع على روابط لمواقع أطراف ثالثة؛ الشركة غير
                      مسؤولة عن سياسات الخصوصية في تلك المواقع، ويُنصح بالاطلاع
                      عليها بشكل مستقل.
                    </li>
                    <li>
                      الشركة لا تتحمل أي مسؤولية عن استخدام معلوماتك من قبل
                      أطراف ثالثة مثل التجار أو الكيانات التجارية أو مواقع الويب
                      التي لا تخضع لسيطرتها، حتى إن ظهرت ضمن المنصة.
                    </li>
                    <li>
                      في حال الشك، يجب عليك مراجعة سياسة الخصوصية وشروط
                      الاستخدام الخاصة بالطرف الثالث ذي الصلة.
                    </li>
                  </ul>
                  <div className="card-header">
                    <h3 className="text-primary card-title">Cookies</h3>
                  </div>

                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      ملف تعريف الارتباط هو ملف نصي صغير يتم نقله إلى جهازك عن
                      طريق خادم ويب.
                    </li>
                    <li>
                      هذا الملف ليس برنامجاً ولا يمكنه قراءة المعلومات أو تنفيذ
                      أنشطة على الجهاز.
                    </li>
                    <li>
                      يُستخدم ملف تعريف الارتباط لتمكين خوادم الشركة من التعرف
                      عليك بسرعة وكفاءة عند العودة إلى استخدام المنصة أو تصفح
                      مواقع أخرى.
                    </li>
                    <li>
                      بموافقتك على شروط الاستخدام، فإنك تسمح للشركة بزرع ملف
                      تعريف ارتباط على جهازك واستخدام البيانات المخزنة فيه
                      للتعرف عليك.
                    </li>
                    <li>
                      قد تستخدم الشركة معلومات من ملفات تعريف الارتباط لنشر
                      محتوى دعائي مخصص لك على مواقع أطراف ثالثة ("موفرو الطرف
                      الثالث")، دون تحديد هويتك بشكل مباشر.
                    </li>
                    <li>
                      الشركة غير مسؤولة عن تشغيل أو محتوى مواقع الويب الخاصة
                      بمزودي الطرف الثالث، ويُوصى بمراجعة سياسة الخصوصية الخاصة
                      بكل موقع تقوم بزيارته.
                    </li>
                    <li>
                      يمكنك ضبط إعدادات المتصفح الخاص بك لحظر ملفات تعريف
                      الارتباط أو طلب إذن في كل مرة، وذلك من خلال إعدادات
                      المتصفح أو قسم المساعدة.
                    </li>
                    <li>
                      يرجى ملاحظة أن تعطيل ملفات تعريف الارتباط قد يؤثر سلباً
                      على استخدامك للمنصة وعلى توافر بيانات حول تفضيلاتك وعادات
                      التصفح.
                    </li>
                  </ul>
                  <hr className="text-primary" />

                  <h4 className="text-primary text-center">
                    يمكنك الاتصال بنا لطرح أي أسئلة بخصوص سياسة الخصوصية على
                    نموذج الاتصال ، والذي يظهر على صفحة "اتصل بنا" على الموقع
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
    </>
  );
};
export default FtPrivacyPolicy;
